import type { Link, Social } from '@/types/common';
import type { Resource } from '@/components/static-resources/resource-item';

export const RESOURCE_LIST: Resource[] = [
  {
    type: 'Портал',
    label: 'korabli.su',
    href: 'https://korabli.su',
    typeId: 'portal',
  },
  {
    type: 'Турниры',
    label: 'tournaments.korabli.su',
    href: 'https://tournaments.korabli.su/',
    typeId: 'tournaments',
  },
  {
    type: 'Форум',
    label: 'forum.korabli.su',
    href: 'https://forum.korabli.su',
    typeId: 'forum',
  },
];

export const SOCIAL_LIST: Social[] = [
  {
    description: 'Twitch',
    href: 'https://www.twitch.tv/lestakorabli',
    type: 'twitch',
    icon: 'twitch',
  },
    {
    description: 'VK Play Live',
    href: 'https://live.vkplay.ru/lestakorabli',
    type: 'vk',
    icon: 'vk-video',
  },
  {
    description: 'Trovo',
    href: 'https://trovo.live/s/LestaKorabli',
    type: 'trovo',
    icon: 'trovo',
  },

];

export const FOOTER_LINK_LIST: Link[] = [
  {
    link: 'https://lesta.ru/support/ru/products/mk/',
    name: 'Техническая поддержка'
  },
  {
    link: 'https://legal.lesta.ru/privacy-policy/',
    name: 'Политика конфиденциальности'
  },
];
